import { StandardFreightOrderEquipmentType } from 'clerk_common';
import { enumToString, STANDARD_EQUIPMENT_TYPES } from 'clerk_common/enums';
import { intersection } from 'lodash';

export const getEquipmentTypeOptions = (
  filter?: StandardFreightOrderEquipmentType[]
) => {
  let list = [...STANDARD_EQUIPMENT_TYPES];

  if (filter) {
    list = intersection(STANDARD_EQUIPMENT_TYPES, filter);
  }

  return list.map((type) => ({
    id: type,
    label: enumToString(type),
  }));
};
